import {
  baseApi,
  ChatHistoryListResponse,
  ChatRequest,
  ChatResponse,
  ChatTitle,
  DashboardCreate,
} from "@racoon/api";

const chatApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getChats: build.query<ChatTitle[], void>({
      query: () => "/v1/platform/chat/chats",
      providesTags: ["Chats"],
    }),
    askSql: build.mutation<ChatResponse, ChatRequest>({
      query: (body) => ({
        url: "/v1/platform/chat/ask-sql",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Chats"],
    }),
    chatHistory: build.query<ChatHistoryListResponse, string>({
      query: (chat_id) => ({
        url: `/v1/platform/chat/chat-history`,
        params: { chat_id },
      }),
    }),
    saveDashboard: build.mutation<void, DashboardCreate>({
      query: (body) => ({
        url: "/v1/platform/chat/saved-dashboards",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetChatsQuery,
  useAskSqlMutation,
  useChatHistoryQuery,
  useSaveDashboardMutation,
} = chatApi;
